import React, { useEffect, useContext } from "react";
import { parse } from "query-string";
import { useHistory, useLocation } from "react-router-dom";

// auth
import { useAuth } from "frontend/hooks/useAuth";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import {
    setIsReadyForDownload,
    setPurchaseType,
    setDownloadResourceParams,
    setAttributionRequired
} from "core/AssetDownload/Context/actions";

// styles
import colors from "core/colors";
import { RootWrapperStyled, GridContainerStyled } from "./styles";

const RootWrapper = ({ children }) => {
    const { isLoggedIn } = useAuth();
    const queryString = useLocation().search;
    let history = useHistory();
    const { dispatch, state } = useContext(AssetDownloadContext);

    const { purchaseType, assetDownloadConfig } = state;

    const {
        getDownloadResourceParams,
        getPurchaseTypeByKey,
        purchaseTypeKeys,
        atrributionRequiredCheck
    } = assetDownloadConfig;

    /*---------------------------
    | On Mount // First Load
    ---------------------------*/
    useEffect(() => {
        // To mitigate users bookmarking steps 2 & 3, we remove the query from the URL.
        // We hold their choice in state
        // this does not persist, so if user refreshes they will lose their choice.
        const { purchase } = parse(queryString);

        if (purchase) {
            const purchaseKey =
                purchase === "standard_photo"
                    ? purchaseTypeKeys.standard
                    : purchaseTypeKeys.premium;

            dispatch(setPurchaseType(getPurchaseTypeByKey(purchaseKey)));
            dispatch(setIsReadyForDownload(true));
        }

        if (purchase) {
            history.replace(location.pathname);
        }
    }, []);

    /*---------------------------
    | isLoggedIn and Public Domain, should be ready to download
    ---------------------------*/
    useEffect(() => {
        // if public domain, and user is logged in, show ready for download
        if (isLoggedIn && purchaseType.key === purchaseTypeKeys.public) {
            dispatch(setIsReadyForDownload(true));
        }
    }, [isLoggedIn]);

    /*---------------------------
    | Update downloadResourceParams By purchaseType,
        should the user change the type
        or purchases through checkout
    ---------------------------*/
    useEffect(() => {
        dispatch(
            setDownloadResourceParams(getDownloadResourceParams(purchaseType))
        );
        dispatch(
            setAttributionRequired(atrributionRequiredCheck(purchaseType))
        );
    }, [purchaseType]);

    return (
        <RootWrapperStyled bgColor={colors.secondary.orca}>
            <GridContainerStyled
                mobileSpacing={0}
                tabletSpacing={16}
                desktopSpacing={55}
            >
                {children}
            </GridContainerStyled>
        </RootWrapperStyled>
    );
};

export default RootWrapper;
